'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTextInput = require('react-text-input');

var _reactTextInput2 = _interopRequireDefault(_reactTextInput);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _aphrodite = require('aphrodite');

var _localizer = require('../util/localizer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = _aphrodite.StyleSheet.create({
	errorMessage: {
		height: 0,
		transition: 'all 0.25s ease-in-out'
	},

	errorShown: {
		height: '100%'
	}
});

/**
 * CEP component for Brazil
 */

var Cpf = function (_React$Component) {
	_inherits(Cpf, _React$Component);

	function Cpf(props) {
		_classCallCheck(this, Cpf);

		var _this = _possibleConstructorReturn(this, (Cpf.__proto__ || Object.getPrototypeOf(Cpf)).call(this, props));

		_this.handleChange = function (input) {
			var formattedCpf = _this.getFormattedCpf(input);
			_this.setState({
				value: formattedCpf
			});
			_this.props.handleChange(formattedCpf);
			return formattedCpf;
		};

		_this.handleBlur = function () {
			_this.validateAndShowError();
			_this.props.handleBlur();
		};

		_this.handleFocus = function () {
			_this.setState({
				showError: false
			});
			_this.props.handleFocus();
		};

		_this.getErrorMessage = function () {
			if (_this.state.showError) {
				return _this.state.errorMessage;
			}

			return '';
		};

		_this.getFormattedCpf = function (cpf) {
			var digitsOnly = cpf.replace(/\D/g, '');
			var firstElevelDigitsOfCpf = digitsOnly.substring(0, 11);

			var formattedCpf = firstElevelDigitsOfCpf.substring(0, 3);
			if (firstElevelDigitsOfCpf.length > 3) {
				formattedCpf += '.';
			} else {
				return formattedCpf;
			}
			formattedCpf += firstElevelDigitsOfCpf.substring(3, 6);
			if (firstElevelDigitsOfCpf.length > 6) {
				formattedCpf += '.';
			} else {
				return formattedCpf;
			}
			formattedCpf += firstElevelDigitsOfCpf.substring(6, 9);
			if (firstElevelDigitsOfCpf.length > 9) {
				formattedCpf += '-';
			} else {
				return formattedCpf;
			}
			formattedCpf += firstElevelDigitsOfCpf.substring(9, 11);

			return formattedCpf;
		};

		_this.validateAndShowError = function () {
			if (!_this.state.showGuestCPF) {
				return true;
			}

			// Check that CPF is present
			if (!_this.state.value) {
				_this.setState({
					showError: true,
					errorMessage: _this.props.warnings._REQUIRED_CPF
				});
				return false;
			}

			if (!_this.isCpfValid()) {
				_this.setState({
					showError: true,
					errorMessage: _this.props.warnings._INVALID_CPF
				});
				return false;
			}
			return true;
		};

		_this.isCpfValid = function () {
			var cpf = _this.state.value || '';
			var digitsOnly = cpf.replace(/\D/g, '');
			if (digitsOnly.length === 11) {
				return true;
			}
			return false;
		};

		var _props$country = props.country,
		    country = _props$country === undefined ? 'US' : _props$country;

		var countryInfo = (0, _localizer.getCountryInfo)(country);
		var state = {
			showGuestCPF: countryInfo.showGuestCPF || false
		};

		if (props.errorMessageCode) {
			state = _extends({}, state, {
				showError: true,
				errorMessage: props.warnings[props.errorMessageCode]
			});
		}
		_this.state = state;
		return _this;
	}

	_createClass(Cpf, [{
		key: 'UNSAFE_componentWillReceiveProps',
		value: function UNSAFE_componentWillReceiveProps(nextProps) {
			if (nextProps.errorMessageCode) {
				this.setState({
					showError: true,
					errorMessage: this.props.warnings[nextProps.errorMessageCode]
				});
			}
		}

		/**
  * Validates and displays error
  * @return {Boolean} True when validation passes, false otherwise
  */

	}, {
		key: 'render',
		value: function render() {
			if (!this.state.showGuestCPF) {
				return null;
			}

			var errorMessage = this.getErrorMessage();
			var wrapperClassNames = (0, _classnames2.default)({
				'vx_has-error-with-message': errorMessage,
				'vx_has-error': !!errorMessage
			});

			return _react2.default.createElement(
				'div',
				{ className: wrapperClassNames },
				_react2.default.createElement(_reactTextInput2.default, {
					name: 'cpf',
					id: 'cpf',
					className: 'vx_form-control vx_form-control_complex',
					label: this.props.label,
					required: this.props.required,
					value: this.state.value,
					handleChange: this.handleChange,
					onFocus: this.handleFocus,
					handleFocus: this.handleFocus,
					onBlur: this.handleBlur,
					handleBlur: this.handleBlur
				}),
				_react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)((0, _aphrodite.css)(styles.errorMessage, errorMessage && styles.errorShown), {
							'vx_form-control-message': errorMessage
						}) },
					errorMessage
				)
			);
		}
	}]);

	return Cpf;
}(_react2.default.Component);

Cpf.propTypes = {
	handleChange: _propTypes2.default.func,
	handleBlur: _propTypes2.default.func,
	handleFocus: _propTypes2.default.func,
	errorMessageCode: _propTypes2.default.string,
	label: _propTypes2.default.string,
	required: _propTypes2.default.bool,
	value: _propTypes2.default.string,
	warnings: _propTypes2.default.object,
	showError: _propTypes2.default.bool,
	country: _propTypes2.default.string
};
Cpf.defaultProps = {
	handleChange: function handleChange() {},
	handleFocus: function handleFocus() {},
	handleBlur: function handleBlur() {},
	showRequiredError: false,
	errorMessage: ''
};
exports.default = Cpf;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/components/Cpf.js
// module id = 710
// module chunks = 5